import React from 'react';
import { useStyletron } from 'baseui';
import { EMPTY_OBJECT, FormBuilder } from 'commons-ui';
import { FORM_FIELD_CONFIG, FORM_LAYOUT_CONFIG, validationSchema } from './formConfig';
import useLinkAccount from './useLinkAccount';
import { IContentProps } from '../../types';

const LinkAccount = (params: IContentProps) => {
	const [css] = useStyletron();
	const { showLoader, setShowLoader, handleFormSubmit, handleFormCancel } = useLinkAccount(params);

	return (
		<div className={css({ width: '50vw' })}>
			<FormBuilder
				data={EMPTY_OBJECT}
				mode='create'
				showLoader={showLoader}
				handleFormSubmit={handleFormSubmit}
				handleFormCancel={handleFormCancel}
				setShowLoader={setShowLoader}
				fieldConfig={FORM_FIELD_CONFIG}
				layoutConfig={FORM_LAYOUT_CONFIG}
				validationSchema={validationSchema}
				buttonLabels={{
					submitLabel: 'Submit',
					discardLabel: 'Cancel'
				}}
				hidePopUp
			/>
		</div>
	);
};

export default LinkAccount;
